import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Clock, LogOut } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useNavigate } from 'react-router-dom';
import AmbientNetwork from '../components/AmbientNetwork';

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <AmbientNetwork />
      <div className="max-w-md w-full text-center space-y-8 relative z-10">
        {/* Logo */}
        <div className="flex justify-center" data-net-exclude>
          <img 
            src="/icons/ht-logo-v3.png" 
            alt="Hedging Tracker" 
            className="w-20 h-20 rounded-[18px] object-contain ht-logo"
          />
        </div>

        {/* Icon */}
        <div className="flex justify-center" data-net-exclude>
          <div
            className="w-20 h-20 rounded-full border flex items-center justify-center"
            style={{ borderColor: 'rgba(240, 180, 90, 0.45)' }}
          >
            <Clock size={36} className="ht-warn" />
          </div>
        </div>

        {/* Message */}
        <div className="space-y-4" data-net-exclude>
          <h1 className="text-2xl font-bold text-white font-heading">
            In attesa di approvazione
          </h1>
          <p className="text-gray-400">
            Ciao <span className="text-white font-medium">{user?.name}</span>,
          </p>
          <p className="text-gray-400">
            Il tuo account è in attesa di approvazione da parte dell'amministratore.
            Riceverai l'accesso non appena il tuo account verrà approvato.
          </p>
        </div>

        {/* Info Card */}
        <div className="ht-panel p-4" data-net-exclude>
          <p className="text-sm text-[#8b919c]">
            Email: <span className="text-[#e6e9ee]">{user?.email}</span>
          </p>
        </div>

        {/* Logout Button */}
        <div className="flex justify-center" data-net-exclude>
          <button
            type="button"
            onClick={handleLogout}
            className="ht-btn"
            data-testid="logout-btn"
          >
            <LogOut size={14} />
            Esci
          </button>
        </div>
      </div>
    </div>
  );
}
